<template>
  <Modal :hideExit="true" @cancel="closeModal" cClass="mnw848" classs="modal-select-page" preventBackdrop>
    <template #header>
      <p class="typo-heading20 typo-medium text-light-high">{{ $t(header) }}</p>
    </template>
    <template #default>
      <Noti
        v-if="isGemPagesV6 && shouldDisplayMessage"
        class="mb-2"
        type="infor"
        htmlDesc="A/B Testing will soon be available for pages created with GemPages 7.0"
        :isInline="true"
        :isClose="true"
        @onClose="closeMessage"
      >
      </Noti>
      <div class="col-12 p-0 mb-2">
        <div class="form-group">
          <label class="typo-button14 typo-medium text-light-high">
            {{ $t(titles[pageIDs.length]) }}
          </label>
          <!-- <input ref="inputTitle" class="input-field input-field-border input-field-block" type="text" v-focus @keyup.enter="createPage" v-model="pageName" :placeholder="$t('page.btnCreate.modal.placeholder1')" /> -->
          <!-- <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p> -->
        </div>
      </div>
      <div class="col-12 p-0 mb-2">
        <div class="row">
          <div class="col-12 col-md-7 mr-auto">
            <GpTabs class="flex-md-grow-0" @tabChange="changeTab" :active="active" :customNav="true">
              <template v-slot:GpTabsNav="{ activeIndex, handler }">
                <GpTabsNav class="d-flex">
                  <GpTab class="gp-campaigns-tab" v-for="tab in tabsList" to="#" :index="tab.value" :key="'tab_' + tab.value" :activeIndex="activeIndex" @click="handler" :disabled="(type != tab.value && type != '') || (active != tab.value && pageIDs.length > 0)">
                    {{ tab.text }}
                  </GpTab>
                </GpTabsNav>
              </template>
            </GpTabs>
          </div>
          <div class="col-12 col-md-4">
            <div class="row mr-0">
              <GpInputSearch v-model="query" :placeholder="$t('generals.placeholder')" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 p-0 page-list">
        <GpList class="m-nhalf p-half" listType="addPages" @doLoadMore="doLoadMore">
          <template v-slot:GpListItem>
            <template v-if="currentPageType.fetched">
              <GpEmptyPage :page="getPageType()" v-if="!currentPageType.list || !currentPageType.list.length">
                <template #button>
                  <ButtonCreatePage :type="getPageType()" @create="onClickTemplatePage" />
                </template>
              </GpEmptyPage>
              <template v-else-if="!allPagesAdd.length">
                <GpEmptyPage page="search" :customContent="true" v-if="query.trim() != ''">
                  <template #content>
                    <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">{{ $t("search.noResult", { keyword: query }) }}</p>
                    <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("page.searchEmpty") }}</p>
                  </template>
                </GpEmptyPage>
                <GpEmptyPage page="search" :customContent="true" v-else>
                  <template #content>
                    <p class="typo-heading24 typo-semibold text-center text-light-high mb-3" v-html="$t('analytic.ab.outOfPage', {type: $tc('page.'+getPageType(), 1)})"></p>
                    <!-- <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("empty.integrations.searchEmpty") }}</p> -->
                    <ButtonCreatePage :type="getPageType()" @create="onClickTemplatePage" />
                  </template>
                </GpEmptyPage>
              </template>
            </template>
            <template v-else>
              <GpListLoading :quantity="5" />
              <!-- <template v-if="currentPageType.loading"> -->

              <!-- </template>
              <div class="flex-center py-5" v-else>
                <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">{{ $t("page.notFetched") }}</p>
              </div> -->
            </template>
            <PageItem class="d-flex justify-content-between align-items-center mb-3 no-select-hover" v-for="(item, index) in allPagesAdd" :key="item.id + '_' + index" :page="item" :pageType="getPageType(item.g_type)" :listType="getListType(item)" @check="checkedUpdate" :isChecked="isChecked(item)" :disabled="(!isChecked(item) && pageIDs.length >= take) || selecteds.includes(item.id) || (item && item.events && item.events.findIndex(x => x.event == 'schedule_publish') > -1)" />
          </template>
        </GpList>
      </div>
    </template>
    <template #footer>
      <div class="btn-group flex-row-reverse">
        <template>
          <ProcessButton class="btn-primary ml-2" :disabled="!pageIDs || !pageIDs.length" :status.sync="btnStatus" @click="createPage" type="submit">
            <template #loading>{{ $t(primaryText.loading) }}...</template>
            <template #success>{{ $t(primaryText.success) }}</template>
            <template #error>{{ $t(primaryText.error) }}</template> 
            <template #default>{{ $t(primaryText.default) }}</template>
          </ProcessButton>
        </template>

        <button class="btn btn btn-outline" @click="closeModal">{{ $t("generals.cancel") }}</button>
      </div>
    </template>
  </Modal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { ProcessButton } from "@/core/shared";
import GpTabs, { GpTab, GpTabsNav } from "@/core/shared/GpTabs";
import { GpInputSearch } from "@/core/shared/GpForms";
import GpList, { GpListLoading } from "@/core/shared/GpList";
import { mapActions, mapGetters, mapState } from "vuex";
import PageItem from "./PageItem.vue";
import { ButtonCreatePage } from "@/modules/Shopify/components";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
import Noti from "@/core/shared/base/Notification"

export default {
  name: "ModalSelectPage",
  components: {
    Noti,
    GpTabs,
    GpTabsNav,
    GpTab,
    ProcessButton,
    GpInputSearch,
    GpList,
    PageItem,
    GpListLoading,
    ButtonCreatePage,
    GpEmptyPage,
  },
  props: {
    header: {
      type: String,
      default: "analytic.ab.createNewCamp"
    },
    titles: {
      type: Array,
      default: () => ["analytic.ab.selectOrigin", "analytic.ab.selectVariant", "analytic.ab.ready"]
    },
    alertText: {
      type: String,
      default: ""
    },
    btnStatus: {
      type: Object,
      default: () => ({
        loading: false,
        success: false,
        error: false
      })
    },
    primaryText: {
      type: Object,
      default: () => ({
        default: "generals.create",
        error: "generals.error",
        loading: "generals.loading",
        success: "generals.success"
      })
    },
    take: {
      type: Number,
      default: 2
    },
    type: {
      type: String,
      default: ""
    },
    selecteds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      active: "template-page",
      query: "",
      pageIDs: [],

      paginateAddPages: {
        start: 0,
        limit: 10,
        totalShow: 10
      },
      shouldDisplayMessage: false
    };
  },
  computed: {
    ...mapGetters("page", {
      allPages: "allPages",
    }),
    ...mapState("page", {
      pagesList: "pages"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo",
    }),
    currentPageType() {
      let type = this.getPageType(this.active);
      return this.pagesList[type];
    },
    tabsList() {
      return [
        // {
        //   text: this.$t("generals.all"),
        //   value: ""
        // },
        {
          text: this.$t("page.landing"),
          value: "template-page"
        },
        {
          text: this.$t("page.home"),
          value: "template-index"
        },
        {
          text: this.$tc("page.product", 1),
          value: "template-product"
        },
        {
          text: this.$tc("page.collection", 1),
          value: "template-collection"
        },
        {
          text: this.$t("page.type.blog"),
          value: "template-article"
        }
      ];
    },
    allPagesAdd() {
      const list = this.filteredPages.slice(0, this.paginateAddPages.totalShow);
      return list;
    },
    textDefault() {
      return {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      }
    },
    filteredPages() {
      let list = [...this.allPages];
      let q = (this.query || "").trim().toLowerCase();

      list = list
        .filter(e => e.type == this.active)
        .filter(e => {
          // const isOriginalShopifyPage = this.textDefault[e.title] ? true : false;
          const whitelist = ['template-index', 'template-product', 'template-collection'];
          if (whitelist.includes(e.type)) {
            return true;
          }
          return e.isGpTemplate && !e.gp_unlink;
        })
        .filter(e => (e.title || "").toLowerCase().includes(q));

      list = list.sort((a, b) => {
        return new Date(a.updated_at) <= new Date(b.updated_at) ? 1 : -1;
      });

      // list = list.slice(this.paginateAddPages.start, this.paginateAddPages.start + this.paginateAddPages.limit);
      return list;
    },
    isGemPagesV6() {
      return (this && this.shopInfo && this.shopInfo.isGemPagesV7 === 'false') || window.___gemShopInfo.isGemPagesV7 === 'false';
    }
  },
  created() {
    if (this.type != "") {
      this.active = this.type;
    }
    this.checkDataTab();

    const hasGotMessage = localStorage.getItem('gotMessageCreateCampaign');
    this.shouldDisplayMessage = !hasGotMessage;
  },
  methods: {
    ...mapActions("page", {
      fetchPages: "fetchPages",
      createPageWithOneTap: "createPageWithOneTap"
    }),
    closeModal() {
      this.$store.commit("account/IS_MODAL_VIEWING", false);
      this.$emit("close");
    },
    changeTab(index) {
      this.active = index;
      this.checkDataTab();
    },
    checkDataTab() {
      if ((!this.currentPageType.list || !this.currentPageType.list.length) && !this.currentPageType.fetched) {
        this.fetchPages({
          type: this.getPageType(),
          shop: this.shopInfo.shopifyDomain
        });
      }
    },
    createPage() {
      if (!this.pageIDs || !this.pageIDs.length) {
        // this.alertText = this.$t("analytic.ab.atLeast1");
        this.$emit("alert", this.$t("analytic.ab.atLeast1"));
        return;
      }
      this.$emit("select", this.pageIDs, this.active);
    },

    doLoadMore() {
      // this.paginateAddPages.start += this.paginateAddPages.limit;
      // this.allPagesAdd = this.allPagesAdd.concat(this.filteredPages);
      this.paginateAddPages.totalShow += this.paginateAddPages.limit;
    },
    onChangeSearchAddPages() {
      this.paginateAddPages.start = 0;
      this.allPagesAdd = this.filteredPages;
    },
    checkedUpdate(item) {
      if (this.take == 1) {
        if (this.pageIDs.includes(item.id)) {
          this.pageIDs = [];
        } else {
          this.pageIDs = [item.id];
        }
        return;
      }

      let idx = this.pageIDs.findIndex(e => e == item.id);
      if (idx > -1) {
        if (item.value != true) {
          this.pageIDs.splice(idx, 1);
        }
      } else {
        if (this.pageIDs && this.pageIDs.length >= this.take) {
          return;
        }
        this.pageIDs.push(item.id);
      }
    },
    isChecked(item) {
      return this.pageIDs.includes(item.id);
    },
    // eslint-disable-next-line no-unused-vars
    getListType(item) {
      return "addPages";
    },
    getPageType(type) {
      if (type == undefined) {
        type = this.active;
      }
      switch (type) {
        case "template-page": {
          return "subpages";
        }
        case "template-index": {
          return "homepages";
        }
        case "template-collection": {
          return "collectionpages";
        }
        case "template-product": {
          return "productpages";
        }
        case "template-article": {
          return "articlepages";
        }
        default: {
          return "subpages";
        }
      }
    },
    async onClickTemplatePage(type) {
      this.createPageWithOneTap({type});
      // switch (type) {
      //   case "subpages":
      //     this.$router.push({
      //       name: "LandingPagesTemplate"
      //     });
      //     break;
      //   case "articlepages":
      //     this.$router.push({
      //       name: "ArticlePagesTemplate"
      //     });
      //     break;
      //   case "homepages":
      //     this.$router.push({
      //       name: "HomePagesTemplate"
      //     });
      //     break;
      //   case "collectionpages":
      //     this.$router.push({
      //       name: "CollectionPagesTemplate"
      //     });
      //     break;
      //   case "productpages":
      //     this.$router.push({
      //       name: "ProductPagesTemplate"
      //     });
      //     break;
      // }
    },
    closeMessage() {
      localStorage.setItem('gotMessageCreateCampaign', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.gp-tabs {
  .gp-tabs-nav {
    &.no-min-height {
      min-height: unset;
    }
    .gp-tabs-nav-item {
      white-space: nowrap;
      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  }
}
::v-deep {
  .gem-page-list.list-scroll {
    height: calc(100vh - 320px);
    min-height: 212px;
    max-height: 424px;
    overflow-y: overlay;
  }
}
.page-list {
  max-width: 780px;
}
</style>
